<template>
  <div class="new-module-content-bg-grey">
    <div class="flow-page">
      <div class="page-title">
        <p class="title-text">参赛流程</p>
        <span class="text-en">APPLICATION PROCESS</span>
      </div>
      <stepActive :stepNum="2"/>
      <div class="input-module">
        <p class="input-tip">注：*为必填</p>
        <moduleTop top-text="上传作品管理"/>
        <div class="input-upload-module">
          <div class="work-handle-box" v-if="multipleWorks">
            <div class="work-length">
              <template v-for="(workItem) in workUploadArr.length">
                <span @click="curWorksIndex = workItem -1 " class="work-handle-switch" :key="workItem" :class="{'switch-active':workItem-1 === curWorksIndex}">作品{{ workIndexZh[workItem-1] }}</span>
              </template>
            </div>
            <div class="handle-del-add">
              <p class="handle-item" @click="addWorkFn" v-if="workUploadArr.length <=10">
                <img :src="require('@/assets/add_work_icon.png')" alt="">
                <span>添加更多作品</span>
              </p>
              <p class="handle-item" @click="delWorkFn" v-if="workUploadArr.length >=1">
                <img :src="require('@/assets/del_work_icon.png')" alt="">
                <span>删除作品</span>
              </p>
            </div>
          </div>
          <template v-for="(workItem,workIndex) in workUploadArr">
            <div :key="workIndex" v-show="workIndex === curWorksIndex" class="">
              <div class="work-upload-box">
                <div class="upload-left-box">
                  <label :for="`file2-${workIndex}`">
                    <div class="upload-left">
                      <p class="upload-title is-required">上传封面</p>
                      <p class="upload-desc">
                        需按要求上传展示封面，jpg或png，文件大小不超过5M 封面尺寸400px*266px
                      </p>
                      <div :class="{'upload-el':getWorkInfo.race != 5,'upload-el upload-el-race-5':getWorkInfo.race == 5}">
                        <img v-if="workItem.file2.previewUrl == ''" :src="require('@/assets/upload_black_icon.png')" alt="upload" class="upload-icon">
                        <img v-if="workItem.file2.previewUrl" :src="workItem.file2.previewUrl" class="preview">
                        <span v-else-if="workItem.file2.uploading">{{workItem.file2.progress}}%</span>
                      </div>
                    </div>
                  </label>
                  <input hidden type="file" accept=".jpg,.png" :id="`file2-${workIndex}`" @change="getFile($event,workIndex,'file2')">
                  <div class="upload-left-blank"></div>
                  <label v-if="getWorkInfo.race != 5">
                    <div class="upload-left">
                      <p class="upload-title is-required">作品介绍文档</p>
                      <p class="upload-desc">
                        请输入作品说明需在500字以内
                      </p>
                      <textarea class="upload-document" v-model.trim="workItem.document"></textarea>
                      <!--
                      <div :class="{'upload-el upload-el-race-1':getWorkInfo.race === 1,'upload-el upload-el-race-2':getWorkInfo.race != 1}">
                        <img v-if="workItem.file3.previewUrl == ''" :src="require('@/assets/upload_black_icon.png')" alt="upload" class="upload-icon">
                        <img v-if="workItem.file3.previewUrl" :src="workItem.file3.previewUrl" class="preview">
                        <span v-else-if="workItem.file3.uploading">{{workItem.file3.progress}}%</span>
                      </div>-->
                    </div>
                  </label>
                  <!--<input hidden type="file" accept=".doc,.docx" :id="`file3-${workIndex}`"  @change="getFile($event,workIndex,'file3')">-->
                </div>
                <div class="upload-right">
                  <div class="input-list">
                    <div :class="{'input-left-box':getWorkInfo.race === 1 || getWorkInfo.race === 5,'input-line-box mt70':getWorkInfo.race != 1 && getWorkInfo.race != 5}">
                      <div class="input-item item-w is-required">
                        <span class="red">参赛作品名称</span>
                        <input type="text" placeholder=" " v-model.trim="workItem.title">
                      </div>
                      <div class="input-item item-w is-required mt51">
                        <span class="red">{{label_company_name}}</span>
                        <el-select v-model="workItem.company" filterable remote placeholder="请选择院校" :remote-method="searchSchool" v-if="label_company_name !='院校/公司名称'">
                          <el-option
                              v-for="item in arrSchool"
                              :key="item"
                              :label="item"
                              :value="item">
                          </el-option>
                        </el-select>
                        <input type="text" placeholder=" " v-model.trim="workItem.company" v-else-if="label_company_name == '院校/公司名称'">
                      </div>
                    </div>
                    <div :class="{'input-right-box':getWorkInfo.race === 1 || getWorkInfo.race === 5 ,'input-line-box':getWorkInfo.race != 1 && getWorkInfo.race != 5}">
                      <div :class="{'input-item is-required input-cate':getWorkInfo.race === 1 || getWorkInfo.race === 5,'input-item is-required input-cate mt51':getWorkInfo.race != 1 && getWorkInfo.race != 5}">
                        <span class="red">选择作品类型</span>
                        <select :value="workItem.cate" @change="selectFn($event,'cate',workIndex)">
                          <option value ="1">图片</option>
                          <option value ="2">视频</option>
                          <!--<option value ="3">文案</option>-->
                          <!--<option value ="4">音频</option>-->
                        </select>
                      </div>
                      <div class="input-item is-required input-real mt51">
                        <span class="red">参赛作品是否有实物</span>
                        <select :value="workItem.is_real" @change="selectFn($event,'is_real',workIndex)">
                          <option value ="1">是</option>
                          <option value ="2">否</option>
                        </select>
                      </div>
                    </div>
                    <template v-if="getWorkInfo.race === 5">
                      <div class="input-race-waring-box">专项课题赛事需要至少有一位教师带队</div>
                    </template>
                    <div class="input-author-box">
                      <template v-if="getWorkInfo.race != 1">
                        <div class="input-item is-required mt51">
                          <span class="red">参赛作者姓名1</span>
                          <input type="text" placeholder=" " v-model.trim="workItem.author1">
                        </div>
                        <div class="input-item mt51">
                          <span class="red">参赛作者姓名2</span>
                          <input type="text" placeholder=" " v-model.trim="workItem.author2">
                        </div>
                        <div class="input-item mt51">
                          <span class="red">参赛作者姓名3</span>
                          <input type="text" placeholder=" " v-model.trim="workItem.author3">
                        </div>
                      </template>
                      <template v-if="getWorkInfo.race === 1">
                        <div class="input-item input-item-4 is-required mt51">
                          <span class="red">参赛作者姓名1</span>
                          <input type="text" placeholder=" " v-model.trim="workItem.author1">
                        </div>
                        <div class="input-item input-item-4 mt51">
                          <span class="red">参赛作者姓名2</span>
                          <input type="text" placeholder=" " v-model.trim="workItem.author2">
                        </div>
                        <div class="input-item input-item-4 mt51">
                          <span class="red">参赛作者姓名3</span>
                          <input type="text" placeholder=" " v-model.trim="workItem.author3">
                        </div>
                        <div class="input-item input-item-4 mt51">
                          <span class="red">参赛作者姓名4</span>
                          <input type="text" placeholder=" " v-model.trim="workItem.author4">
                        </div>
                      </template>
                      <template v-if="getWorkInfo.race === 5">
                        <div class="input-item mt51">
                          <span class="red">参赛作者姓名4</span>
                          <input type="text" placeholder=" " v-model.trim="workItem.author4">
                        </div>
                        <div class="input-item mt51">
                          <span class="red">参赛作者姓名5</span>
                          <input type="text" placeholder=" " v-model.trim="workItem.author5">
                        </div>
                        <div class="input-item mt51">
                          <span class="red">参赛作者姓名6</span>
                          <input type="text" placeholder=" " v-model.trim="workItem.author6">
                        </div>
                        <div class="input-item input-item-max is-required mt51">
                          <span class="red">团队联系人电话</span>
                          <input type="text" placeholder=" " v-model.trim="workItem.team_phone">
                        </div>
                      </template>
                    </div>
                    <template v-if="getWorkInfo.race === 1">
                      <div class="input-teacher-box">
                        <div class="input-item input-name is-required mt51">
                          <span class="red">指导老师姓名1</span>
                          <input type="text" placeholder=" " v-model.trim="workItem.teacher_realname1">
                        </div>
                        <div class="input-item input-phone is-required mt51">
                          <span class="red">电话</span>
                          <input type="text" placeholder=" " v-model.trim="workItem.teacher_phone1">
                        </div>
                      </div>
                      <div class="input-teacher-box">
                        <div class="input-item input-name mt51">
                          <span class="red">指导老师姓名2</span>
                          <input type="text" placeholder=" " v-model.trim="workItem.teacher_realname2">
                        </div>
                        <div class="input-item input-phone mt51">
                          <span class="red">电话</span>
                          <input type="text" placeholder=" " v-model.trim="workItem.teacher_phone2">
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
              <div class="work-upload-box handle-module ">
                <label :for="`file4-${workIndex}`">
                  <div class="upload-left">
                    <div class="template-download-box">
                      <div class="template-download-icon"></div>
                      <span><a :href="work_board_template_url" target="_blank">展示模板下载</a></span>
                    </div>
                    <p class="upload-title is-required">上传展板</p>
                    <p class="upload-desc">
                      请按照大赛上传作品规范正确上传您的作品。（将作品文件编排与A3幅面竖式，300dpi, jpg, RGB/CMYK,作品大小不超过10MB)<br/>
                      <span>展示展板将用于评审等场景，不要出现任何作者姓名和院校信息，将直观影响比赛成绩或视为无效。</span>
                    </p>
                    <div class="upload-el">
                      <img v-if="workItem.file4.previewUrl == ''" :src="require('@/assets/upload_black_icon.png')" alt="upload" class="upload-icon">
                      <img v-if="workItem.file4.previewUrl" :src="workItem.file4.previewUrl" class="preview">
                      <span v-else-if="workItem.file4.uploading">{{workItem.file4.progress}}%</span>
                    </div>
                  </div>
                </label>
                <input hidden type="file" accept=".jpg,.png" :id="`file4-${workIndex}`"  @change="getFile($event,workIndex,'file4')">
              </div>
              <div class="work-upload-box handle-module" v-if="getWorkInfo.race === 5">
                <label :for="`file3-${workIndex}`">
                  <div class="upload-left">
                    <p class="upload-title is-required">设计说明/策划方案上传</p>
                    <p class="upload-desc">仅支持PDF格式文档</p>
                    <div class="upload-el">
                      <img v-if="workItem.file3.previewUrl == ''" :src="require('@/assets/upload_black_icon.png')" alt="upload" class="upload-icon">
                      <img v-if="workItem.file3.previewUrl" :src="workItem.file3.previewUrl" class="preview">
                      <span v-else-if="workItem.file3.uploading">{{workItem.file3.progress}}%</span>
                    </div>
                  </div>
                </label>
                <input hidden type="file" accept=".pdf" :id="`file3-${workIndex}`"  @change="getFile($event,workIndex,'file3')">
              </div>
              <div class="work-upload-box pb62 un-border">
                <div class="upload-left">
                  <p class="upload-title mb20 is-required">上传作品</p>
                  <p class="upload-desc">请按照大赛上传作品规范正确上传您的作品（可上传6个作品文件）<span>上传完整作品或视频文件</span></p>
                  <div class="upload-item" v-for="(workFileItem,workFileIndex) in workItem.file1" :key="workFileIndex">
                    <img v-if="workFileIndex != 0" :src="require('@/assets/work_del_icon.png')" alt="del" class="upload-del-icon" @click="workDel(workIndex,workFileIndex)">
                    <img v-if="workFileItem.previewUrl == ''" :src="require('@/assets/upload_black_icon.png')" alt="upload" class="upload-icon">
                    <img v-if="workFileItem.previewUrl" :src="workFileItem.previewUrl" class="preview">
                    <span v-else-if="workFileItem.uploading">{{workFileItem.progress}}%</span>
                    <input v-if="workFileIndex == 0" type="file" accept=".jpg,.png,.mp4,.mp3,.pdf" :id="`file1-${workIndex}`" @change="getFileItem($event,workIndex)" class="upload-word">
                  </div>
                </div>
              </div>
              <div class="work-upload-box handle-module un-border" v-show="false">
                <label :for="`file5-${workIndex}`">
                  <div class="upload-left">
                    <div class="template-download-box">
                      <div class="template-download-icon"></div>
                      <span><a :href="work_doc_template_url" target="_blank">承诺书下载</a></span>
                    </div>
                    <p class="upload-title is-required">承诺书上传</p>
                    <p class="upload-desc">
                      仅支持PDF格式文档
                    </p>
                    <div class="upload-el">
                      <img v-if="workItem.file5.previewUrl == ''" :src="require('@/assets/upload_black_icon.png')" alt="upload" class="upload-icon">
                      <img v-if="workItem.file5.previewUrl" :src="workItem.file5.previewUrl" class="preview">
                      <span v-else-if="workItem.file5.uploading">{{workItem.file5.progress}}%</span>
                    </div>
                  </div>
                </label>
                <input hidden type="file" accept=".pdf" :id="`file5-${workIndex}`"  @change="getFile($event,workIndex,'file5')">
              </div>
            </div>
          </template>
          <div class="handle-box">
            <span class="handle-next" @click="$router.back()">返回</span>
            <span class="handle-next-red" :class="{'disabled':!canNextFn}" @click="toSetp3">下一步</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import stepActive from "@/views/flow/components/stepActive";
import moduleTop from "@/components/moduleTop";
import $ from "jquery"
import {Warning} from "@/plugins/warning";
import {mapGetters} from "vuex";
import {submitUserWorks,getRaceInfo,getSearchSchoolFilter} from "@/request/api";
const OSS = require('ali-oss')
export default {
  name: "step1",
  components:{
    stepActive,
    moduleTop
  },
  data() {
    return {
      workIndexZh:['一','二','三','四','五','六','七','八','九','十'],
      curWorksIndex: 0,
      query: {},
      arrSchool:[],
      workUploadArr:[
        {
          file1: [{
            uploading: false,
            fileUrl: '',
            previewUrl: '',
            suffix: '',
            progress: 0
          }],
          file2: {
            uploading: false,
            fileUrl: '',
            previewUrl: '',
            progress: 0
          },
          file3: {
            uploading: false,
            fileUrl: '',
            previewUrl: '',
            progress: 0
          },
          file4: {
            uploading: false,
            fileUrl: '',
            previewUrl: '',
            progress: 0
          },
          file5: {
            uploading: false,
            fileUrl: '',
            previewUrl: '',
            progress: 0
          },
          cate: 1,
          is_real: 2,
          title: '',
          teacher_realname1: '',
          teacher_phone1: '',
          teacher_realname2: '',
          teacher_phone2: '',
          company: '',
          author1: '',
          author2: '',
          author3: '',
          author4: '',
          author5: '',
          author6: '',
          team_phone: '',
        },
      ],
      work_board_template_url:'',
      work_doc_template_url:'',
      multipleWorks:false,
      label_company_name:'',
    }
  },
  computed: {
    ...mapGetters('infoModule',['getWorkInfo']),
    canNextFn(){
      const {workUploadArr} = this;
      return workUploadArr.every(item=>{
        let canNext;
        if(this.getWorkInfo.race == 5){
          canNext = item.file1.length > 0 && item.file2.fileUrl && item.file3.fileUrl && item.title && item.team_phone
        }else{
          canNext = item.file1.length > 0 && item.file2.fileUrl && item.title && item.document
        }
        if(this.getWorkInfo.race === 1){
          if(canNext === true){
            canNext = (item.student_realname && item.teacher_realname && item.school)
          }
        }else{
          if(canNext === true){
            canNext = (item.company && item.author)
          }
        }
        return canNext
      })
    }
  },
  created() {
    this.query = this.$route.query
    console.log(this.getWorkInfo)
    if(this.getWorkInfo.race == 1){
      this.label_company_name = '院校名称'
    }else if(this.getWorkInfo.race == 2){
      this.label_company_name = '院校名称'
    }else if(this.getWorkInfo.race == 3){
      this.label_company_name = '院校/公司名称'
    }else if(this.getWorkInfo.race == 5){
      this.label_company_name = '院校名称'
    }
    else{
      this.label_company_name = '院校/公司名称'
    }
    this.getRaceObjFn()
  },
  mounted() {
  },
  methods: {
    selectFn(e,key,index){
      this.$set(this.workUploadArr[index],key,e.target.value)
      console.log(this.workUploadArr)
    },
    getFile(e,index,fileType){
      const that = this;
      const file = e.target.value;
      let filename=file.replace(/.*(\/|\\)/, "");
      let fileExt=(/[.]/.exec(filename)) ? /[^.]+$/.exec(filename.toLowerCase()) : '';
      // console.log(fileType,this.workUploadArr[index][fileType])
      that.$set(that.workUploadArr[index][fileType],'uploading',true)
      let storage = JSON.parse(window.localStorage.getItem('STORAGE'));
      console.log(storage.infoModule)
      $.ajax({
        url: process.env.VUE_APP_SERVER_URL+'/works/uploads/index',
        data:{
          suffix:fileExt[0],
          path:"works"
        },
        headers:{
          Authorization:storage.infoModule.token
        },
        async: true,
        global: false,
        type: 'POST',
        dataType: 'json',
        timeout:1000*7,
        success: function(data) {
          if (data.status === 200) {
            const client = new OSS({
              region: data.result.data.region,
              accessKeyId: data.result.data.access_key_id,
              accessKeySecret: data.result.data.access_key_secret,
              stsToken: data.result.data.security_token,
              bucket: data.result.data.bucket,
            });

            client.multipartUpload(data.result.data.key, e.target.files[0], {
              // 设置上传回调。
              progress:(p) => {
                if(p>=1){
                  setTimeout(function () {
                    that.$set(that.workUploadArr[index][fileType],'fileUrl',data.result.data.url)
                    that.$set(that.workUploadArr[index][fileType],'previewUrl',data.result.data.preview_url)
                    that.$set(that.workUploadArr[index][fileType],'uploading',false)
                  }, 500);
                }else{
                  that.$set(that.workUploadArr[index][fileType],'progress',(p*100) >> 0)
                }
              }
            });
          }else {
            that.$set(that.workUploadArr[index][fileType],'fileUrl','')
            that.$set(that.workUploadArr[index][fileType],'previewUrl','')
            that.$set(that.workUploadArr[index][fileType],'uploading',false)
            Warning.open(data.msg);
          }
        }
      })
    },
    getFileItem(e,index){
      const that = this;
      const file = e.target.value;
      if(file != ''){
        let filename=file.replace(/.*(\/|\\)/, "");
        let fileExt=(/[.]/.exec(filename)) ? /[^.]+$/.exec(filename.toLowerCase()) : '';
        let itemIndex = that.workUploadArr[index]['file1'].length;
        if(itemIndex > 6){
          Warning.open("上传作品数量不超过6张");
          return;
        }
        that.workUploadArr[index]['file1'].push({
          uploading: true,
          fileUrl: '',
          previewUrl: '',
          suffix: '',
          progress: 0
        })
        let storage = JSON.parse(window.localStorage.getItem('STORAGE'));
        console.log(storage.infoModule)
        $.ajax({
          url: process.env.VUE_APP_SERVER_URL + '/works/uploads/index',
          data:{
            suffix:fileExt[0],
            path:"works"
          },
          headers:{
            Authorization:storage.infoModule.token
          },
          async: true,
          global: false,
          type: 'POST',
          dataType: 'json',
          timeout:1000*7,
          success: function(data) {
            if (data.status === 200) {
              const client = new OSS({
                region: data.result.data.region,
                accessKeyId: data.result.data.access_key_id,
                accessKeySecret: data.result.data.access_key_secret,
                stsToken: data.result.data.security_token,
                bucket: data.result.data.bucket,
              });

              client.multipartUpload(data.result.data.key, e.target.files[0], {
                // 设置上传回调。
                progress:(p) => {
                  if(p>=1){
                    setTimeout(function () {
                      that.$set(that.workUploadArr[index]['file1'][itemIndex],'fileUrl',data.result.data.url)
                      that.$set(that.workUploadArr[index]['file1'][itemIndex],'previewUrl',data.result.data.preview_url)
                      that.$set(that.workUploadArr[index]['file1'][itemIndex],'uploading',false)
                      that.$set(that.workUploadArr[index]['file1'][itemIndex],'suffix',fileExt[0])
                    }, 500);
                  }else{
                    that.$set(that.workUploadArr[index]['file1'][itemIndex],'progress',(p*100) >> 0)
                  }
                }
              });
            }else {
              that.$set(that.workUploadArr[index]['file1'][itemIndex],'fileUrl','')
              that.$set(that.workUploadArr[index]['file1'][itemIndex],'previewUrl','')
              that.$set(that.workUploadArr[index]['file1'][itemIndex],'uploading',false)
              Warning.open(data.msg);
            }
          }
        })
      }
    },
    workDel(workIndex,workFileIndex){
      const that = this;
      that.workUploadArr[workIndex]['file1'].splice(workFileIndex,1)
    },
    addWorkFn(){
      this.workUploadArr.push({
        file1: [{
          uploading: false,
          fileUrl: '',
          previewUrl: '',
          suffix: '',
          progress: 0
        }],
        file2: {
          uploading: false,
          fileUrl: '',
          previewUrl: '',
          progress: 0
        },
        file3: {
          uploading: false,
          fileUrl: '',
          previewUrl: '',
          progress: 0
        },
        file4: {
          uploading: false,
          fileUrl: '',
          previewUrl: '',
          progress: 0
        },
        file5: {
          uploading: false,
          fileUrl: '',
          previewUrl: '',
          progress: 0
        },
        cate: 1,
        is_real: 2,
        title: '',
        teacher_realname1: '',
        teacher_phone1: '',
        teacher_realname2: '',
        teacher_phone2: '',
        company: '',
        author1: '',
        author2: '',
        author3: '',
        author4: '',
        author5: '',
        author6: '',
        team_phone: '',
      })
      this.curWorksIndex++
    },
    delWorkFn(){
      const {curWorksIndex,workUploadArr} = this
      if(workUploadArr.length > 1){
        this.workUploadArr.splice(curWorksIndex,1)
        this.curWorksIndex = curWorksIndex - 1 > 0 ?curWorksIndex - 1: 0
      }
    },
    toSetp3(){
      const {canNextFn} = this;
      if(canNextFn){
        const {workUploadArr,getWorkInfo} = this
        const base_info = {
          user_id:'',
          topic: parseInt(getWorkInfo.topic),
          race: parseInt(getWorkInfo.race),
          //invite_code: getWorkInfo.inCode
        }
       const work_info =  workUploadArr.map((item)=>{
          item.works_path = item.file1.fileUrl;
          item.cover_img = item.file2.fileUrl;
          item.document_path = item.file3.fileUrl;
          item.board_path = item.file4.fileUrl;
          item.promise_path = item.file5.fileUrl;
          item.race = parseInt(item.race)
          item.topic = parseInt(item.topic)
          item.cate = parseInt(item.cate)
          item.is_real = parseInt(item.is_real)
          // delete item.file1
          // delete item.file2
          // delete item.file3
          return item
        });
        const data = {
          base_info,
          work_info
        }
        let requestData = {
          data:JSON.stringify(data)
        }
        submitUserWorks(requestData).then(()=>{
          this.$store.commit('infoModule/updateWorkInfo',{})
          this.$router.replace({name:'flowStep3'})
        })
        console.log(requestData)
      }
    },
    getRaceObjFn(){
      const requestData = {
        id: this.getWorkInfo.race
      }
      getRaceInfo(requestData).then(res=>{
        this.raceObj = res.data
        this.work_doc_template_url = this.raceObj.doc_url+'?response-content-disposition=attachment;filename="承诺书.pdf"';
        this.work_board_template_url = this.raceObj.board_url+'?response-content-disposition=attachment;filename="展示模板.pdf"';
        // this.htmlContent = res.data[type]
      })
    },
    searchSchool(key){
      if(key == null || key == undefined || key == ''){
        this.arrSchool = [];
        return;
      }
      const requestData = {
        school: key,
      };
      getSearchSchoolFilter(requestData).then((res)=>{
        this.arrSchool = res.data;
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  @import "~@/css/var.scss";
  .flow-page {
    width: $mainWidth;
    margin: 0 auto;
    padding-bottom: 135px;
    .input-module {
      position: relative;
      margin-top: 114px;
      .input-tip {
        font-size: 23px;
        color: #c3ad94;
        margin-bottom: 14px;
        position: absolute;
        top:40px;
        left: 260px;
      }
      .input-upload-module {
        padding: 35px 0 100px 0;

        background-color: #fff;
        .work-handle-box {
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          padding: 0 177px 0 52px;
          .work-length {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-right: 100px;
            flex-wrap: wrap;
            margin-top: -30px;
            .work-handle-switch {
              display: block;
              width: 116px;
              text-align: center;
              line-height: 40px;
              color: #fff;
              background-color: #c7b299;
              font-weight: bold;
              font-size: 28px;
              margin-right: 42px;
              margin-top: 30px;
              cursor: pointer;
              &:nth-last-of-type(1){
                margin-right: 0;
              }
              &.switch-active {
                background-color: $bgColor-2;
              }
            }
          }
          .handle-del-add {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex-shrink: 0;
            padding-top: 3px;

            .handle-item {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              font-size: 18px;
              color: $bgColor-2;
              font-weight: bold;
              margin-right: 45px;
              cursor: pointer;
              &:nth-last-of-type(1){
                margin-right: 0;
              }
              & > img {
                display: block;
                width: 33px;
                margin-right: 21px;
              }
            }
          }
        }
        .work-upload-box {
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          padding: 60px 100px 42px 100px;
          font-size: 28px;
          font-weight: bold;
          color: #000;
          border-bottom: 1px solid $blockColor--1;
          &.un-border {
            border-bottom: none;
          }
          &.handle-module {
            padding-bottom: 80px;
          }
          &:nth-last-of-type(1){
            border-bottom: none;
          }
          .upload-left-box{
            .upload-left-blank{
              height: 30px;
              width: 30px;
            }
          }
          .upload-left {
            position: relative;
            .upload-desc {
              margin-top: 18px;
              margin-bottom: 30px;
              font-size: 18px;
              color: #5e5d5d;
              line-height: 26px;
              font-weight: normal;
              & > a{
                color: #5e5d5d;
              }
              & > span{
                color: #BA0704
              }
            }
            .upload-document{
              width: 474px;
              height: 274px;
              padding: 10px;
              border: 1px solid $blockColor--1;
              display: flex;
            }
            .template-download-box{
              height: 36px;
              position: absolute;
              top:-4px;
              left: 170px;
              cursor: pointer;
              z-index: 999;
              .template-download-icon{
                width: 27px;
                height: 36px;
                background: url(~@/assets/template_download_icon.png) no-repeat center center;
                background-size: 27px;
                float: left;
                cursor: pointer;
              }
              & > span{
                color: #BA0704;
                font-size: 18px;
                font-weight: normal;
                float: left;
                margin-top: 6px;
                margin-left: 10px;
                cursor: pointer;
                & > a{
                  color: #BA0704;
                  font-size: 18px;
                  font-weight: normal;
                }
              }
            }
            .upload-el {
              width: 474px;
              height: 274px;
              border: 1px solid $blockColor--1;
              display: flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;
              position: relative;
              & > .upload-icon {
                display: block;
                width: 63px;
              }
              & > .preview {
                display: block;
                height:100%;
                width:100%;
                object-fit: contain
              }
              & > span {
                display: block;
                width: 100%;
                height: 100%;
                position: absolute;
                background-color: rgba(0,0,0, .3);
                text-align: center;
                line-height: 332px;
                font-size: 18px;
                color: #fff;
                pointer-events: none
              }
            }
            .upload-el-race-5{
              height: 520px;
            }
            .upload-el-race-1{
              height: 239px;
            }
            .upload-el-race-2{
              height: 157px;
            }
            .upload-item {
              width: 232px;
              height: 232px;
              border: 1px solid $blockColor--1;
              display: flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;
              position: relative;
              float: left;
              margin-right: 15px;
              margin-bottom: 15px;
              & > .upload-icon {
                display: block;
                width: 63px;
              }
              & > .upload-del-icon {
                width: 26px;
                height: 26px;
                z-index: 1;
                position: absolute;
                right: 10px;
                top: 10px;
              }
              & > .upload-word{
                width: 232px;
                height: 232px;
                z-index: 1;
                opacity: 0;
                position: absolute;
                cursor: pointer;
              }
              & > .preview {
                display: block;
                height:100%;
                width:100%;
                object-fit: contain
              }
              & > span {
                display: block;
                width: 100%;
                height: 100%;
                position: absolute;
                background-color: rgba(0,0,0, .3);
                text-align: center;
                line-height: 232px;
                font-size: 18px;
                color: #fff;
                pointer-events: none
              }
            }
          }
          .upload-right {
            width: 100%;
            padding-left: 98px;
            .input-list {
              display: flex;
              justify-content: space-between;
              align-items: flex-start;
              flex-wrap: wrap;
              .input-item {
                font-size: 21px;
                flex-shrink: 0;
                margin-bottom: 18px;
                width: 100%;
                &.item-w {
                  width: 100%;
                }
                & > span {
                  display: block;
                  margin-bottom: 20px;
                }
                & > input,
                & > select{
                  display: block;
                  width: 100%;
                  height: 59px;
                  border: 0.5px solid $blockColor--1;
                  padding: 0 20px;
                }
                & > select {
                  text-align: center;
                  appearance: none;
                  -webkit-appearance: none;   /*去除chrome浏览器的默认下拉图片*/
                  -moz-appearance: none;  /*去除Firefox浏览器的默认下拉图片*/
                  background: url('~@/assets/select_down_icon.png') no-repeat right 10px center;
                  background-size: 19px 11.6px;
                }
                .el-select{
                  display: block;
                  width: 100%;
                  height: 59px;
                  border: 0.5px solid #707070;
                }
              }
              .input-left-box{
                width: 411px;
              }
              .input-right-box{
                width: 215px;
              }
              .input-line-box{
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                flex-wrap: wrap;
                width: 100%;
                .input-cate{
                  width: 313px;
                }
                .input-real{
                  width: 313px;
                }
              }
              .input-author-box{
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                flex-wrap: wrap;
                width: 100%;
                .input-item{
                  width: 195px;
                }
                .input-item-4{
                  width: 145px;
                }
                .input-item-max{
                  width: 100%
                }
              }
              .input-race-waring-box{
                height: 18px;
                font-family: PingFang HK;
                font-size: 18px;
                font-weight: normal;
                line-height: 18px;
                color: #BA0704;
                margin-top: 25px;
              }
              .input-teacher-box{
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                flex-wrap: wrap;
                width: 100%;
                .input-name{
                  width: 195px;
                }
                .input-phone{
                  width: 431px;
                }
              }
              .mt51{
                margin-top: 51px;
              }
              .mt70{
                margin-top: 78px;
              }
            }
          }
          .upload-title{
            font-size: 21px;
          }
        }
      }
    }
  }
  .is-required {
    position: relative;
    font-size: 21px;
    &::before {
      content: '*';
      position: absolute;
      left: -15px;
      top: 4px;
    }
  }
  .is-required-red {
    position: relative;
    &::before {
      content: '*';
      position: absolute;
      left: -15px;
      top: 4px;
      color: red;
    }
    & > .red{
      color: red;
    }
  }
  .handle-box {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 62px;
  }
  .handle-next {
    display: block;
    width: 185px;
    line-height: 48px;
    text-align: center;
    color: #000;
    font-weight: 300;
    border: 1px solid $blockColor--1;
    cursor: pointer;
    margin-right: 26px;
    &.disabled {
      color: #959595;
      background-color: #ddd;
      border: 1px solid #ddd;
    }
  }
  .handle-next-red{display: block;
    width: 185px;
    line-height: 48px;
    text-align: center;
    color: #fff;
    background-color: #BA0704;
    font-weight: 300;
    //border: 1px solid $blockColor--1;
    cursor: pointer;
    margin-right: 26px;
    &.disabled {
      color: #959595;
      background-color: #ddd;
      border: 1px solid #ddd;
    }
  }
</style>
<style>

.el-input__inner{
  height: 57px;
  border: 0;
}
</style>
